/*! License details at fancyapps.com/license */
var t = function t() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "--f-scrollbar-compensate";
  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "--f-body-margin";
  var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "hide-scrollbar";
  var n = document,
    r = n.body,
    l = n.documentElement;
  if (t) {
    if (r.classList.contains(o)) return;
    var _t = window.innerWidth - l.getBoundingClientRect().width;
    _t < 0 && (_t = 0), l.style.setProperty(e, "".concat(_t, "px"));
    var _n = parseFloat(window.getComputedStyle(r).marginRight);
    _n && r.style.setProperty(s, "".concat(_n, "px")), r.classList.add(o);
  } else r.classList.remove(o), r.style.setProperty(s, ""), n.documentElement.style.setProperty(e, "");
};
export { t as scrollLock };